/*
 * Copyright (c) 2020. Denis Rendler <connect@rendler.me>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";

// here we store default values that do not change across envs
// IMPORTANT: first level vars will be overridden and NOT merged
export const config = {
    "expirationOptions": [
        {"value": "on-read", "text": "After Opening"},
        {"value": "5m", "text": "5 minutes"},
        {"value": "30m", "text": "30 minutes"},
        {"value": "1h", "text": "1 hour"},
        {"value": "24h", "text": "1 day"},
        {"value": "48h", "text": "2 days"},
        {"value": "168h", "text": "7 days"}
    ]
};

export const ConfigContext = React.createContext(config);
